<template>
  <div class="template-style">
    <div class="container-wrapper">
      <div
        id="t-scroll-container"
        ref="scrollContainer"
        class="main-scroll"
        :class="{ 'stop-scroll': stopScroll }"
      >
        <slot ref="main" name="main"></slot>
      </div>
      <slot name="container-absolute-item"></slot>
    </div>
    <div class="bottom-fix" @touchmove.prevent>
      <slot name="bottom"></slot>
    </div>
    <slot name="fix-items"></slot>
    <slot name="modal"></slot>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
// import { setTimeout } from 'timers';

@Component({})
export default class TemplateLayout extends Vue {
  @Prop({ type: Boolean, default: false }) stopScroll!: boolean;
  mounted() {
    let i: any;
    const scrollEle = this.$refs.scrollContainer;
    if (scrollEle) {
      this.scrollFix(scrollEle);
    }
  }
  scrollFix(elem: HTMLElement) {
    const handle = function (event: TouchEvent) {
      let startTopScroll;
      const startY = event.touches[0] && event.touches[0].pageY;
      if (startY) {
        startTopScroll = elem.scrollTop;
        // 当滚动条在最顶部的时候
        if (startTopScroll <= 0) elem.scrollTop = 1;
        // 当滚动条在最底部的时候
        if (startTopScroll + elem.offsetHeight >= elem.scrollHeight)
          elem.scrollTop = elem.scrollHeight - elem.offsetHeight - 1;
      }
    };
    elem.addEventListener('touchstart', handle, false);
    this.beforeDestroy = () => {
      elem.removeEventListener('touchstart', handle, false);
    };
    return handle;
  }
}
</script>

<style lang="scss" scoped>
.template-style {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  .container-wrapper {
    position: relative;
    flex: 1;
    width: 100%;
    overflow: hidden;
  }
  .main-scroll,
  .bottom-fix {
    width: 100%;
    // background: #fff;
  }
  .main-scroll {
    position: relative;
    height: 100%;
    overflow: scroll;
  }
  .stop-scroll {
    overflow: hidden;
  }
}
</style>
